import React, { createContext, useContext } from 'react';

const EnvironmentContext = createContext();

export function EnvironmentProvider({ children }) {
  const isDevelopment = process.env.REACT_APP_ENVIRONMENT == 'development';

  return (
    <EnvironmentContext.Provider value={{ isDevelopment }}>
      {children}
    </EnvironmentContext.Provider>
  );
}

export function useEnvironment() {
  const context = useContext(EnvironmentContext);
  if (context === undefined) {
    throw new Error('useEnvironment must be used within an EnvironmentProvider');
  }
  return context;
} 